import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import ROUTES from 'constants/routes';
import { formatFilterToObject, formatSortByToObject } from 'app/api/helpers';
import { hashFiltersToURL } from 'features/sagaHelpers';
import { getArrangedFilters } from 'features/helpers';
import { fetchReturns, postAddNewReturn } from 'services/orderManagement/actions';
import { errorToasterSaga, successToasterSaga } from 'services/sagaWorkers';
import { ACTIONS } from '../constants';
import {
  loadReturns,
  loadReturnsSuccess,
  loadReturnsError,
  setFilters,
  loadFeed,
  submitAddNewReturnError,
  submitAddNewReturnSuccess,
} from '../actions';
import {
  getSettingsItemsPerPage,
  getSettingsSorting,
  getLastPage,
  getFilters,
  selectReturnData,
} from '../selectors';


export function* getReturnProcessingParams(otherParams = {}) {
  const itemsPerPage = yield select(getSettingsItemsPerPage);
  const { columnId, direction } = yield select(getSettingsSorting);
  const page = yield select(getLastPage);
  const sortBy = yield call(formatSortByToObject, columnId, direction);
  const filters = yield select(getFilters);
  const filter = yield call(formatFilterToObject, filters);


  // yield call(hashFiltersToURL, filters, ROUTES.ORDER_MANAGEMENT.RETURNS);

  const params = {
    itemsPerPage,
    page,
    sortBy,
    filter,
    ...otherParams,
  };

  return params;

  // yield put(loadFeed());
  // yield put(fetchReturns(params, loadReturnsSuccess, loadReturnsError));
}

function* requestReturnsFeed(otherParams = {}) {
  const filters = yield select(getFilters);
  yield call(hashFiltersToURL, filters, ROUTES.ORDER_MANAGEMENT.RETURNS);
  const params = yield call(getReturnProcessingParams, otherParams);
  yield put(loadFeed());
  yield put(fetchReturns(params, loadReturnsSuccess, loadReturnsError));
}



export function* loadReturnsWatcher() {
  yield call(requestReturnsFeed);
}

function* loadReturnsErrorWatcher({ errorMessage }) {
  yield call([toast, toast.error], errorMessage);
}

function* arrangeFiltersWatcher({ destination, source }) {
  const filters = yield select(getFilters);
  const updatedFilters = yield call(getArrangedFilters, destination, source, filters);
  yield put(setFilters(updatedFilters));
  if (JSON.stringify(filters) !== JSON.stringify(updatedFilters)) {
    yield put(loadReturns());
  }
}

function* submitAddNewReturnSuccessWatcher() {
  yield call(successToasterSaga, { message: 'New Return Successfully Added.' });
  yield put(loadReturns());
}

function* submitAddNewReturnWatcher() {
  const returnData = yield select(selectReturnData);
  const params = {
    returnData
  };
  yield put(postAddNewReturn(params, submitAddNewReturnSuccess, submitAddNewReturnError));
}

export default function* returnSagas() {
  yield all([
    takeEvery(
      [
        ACTIONS.LOAD_RETURNS,
        ACTIONS.REFRESH_RETURNS_FEED,
        ACTIONS.SORT_RETURN_FEED,
        ACTIONS.SET_FILTER_OPERAND,
        ACTIONS.UNSET_FILTER_OPERAND,
        ACTIONS.CLEAR_FILTERS,
        ACTIONS.SET_ITEMS_PER_PAGE,
        ACTIONS.GO_TO_PAGE,
      ],
      loadReturnsWatcher,
    ),
    takeEvery(ACTIONS.LOAD_RETURNS_ERROR, loadReturnsErrorWatcher),
    takeEvery(ACTIONS.ARRANGE_FILTERS, arrangeFiltersWatcher),
    takeEvery(ACTIONS.ADD_RETURN_DATA, submitAddNewReturnWatcher),
    takeEvery(ACTIONS.ADD_RETURN_DATA_SUCCESS, submitAddNewReturnSuccessWatcher),
    takeEvery(ACTIONS.ADD_RETURN_DATA_ERROR, errorToasterSaga),
  ]);
}
